export default "__VITE_ASSET__Cf45q4b6__"